import React, { useEffect } from "react";
//import React  from 'react';
import './App.css';
import Routes from "./components/router";
import Navbar from './components/Navbar';
import './styles/style.scss'
import Footer from './components/Footer';
import useWindowSize from './components/utils/useWindowSize';
import checkDevice from './components/utils/checkDevice';
import MobileNavbar from './components/MobileNavbar';
import Placeholder from "./components/Placeholder";
import UpperNavbar from "./components/UpperNavbar";
import AOS from 'aos';
import 'aos/dist/aos.css';
import LanguageProvider from "./components/Provider/LanguageProvider";

function App() {
  const size = useWindowSize();
  const isMobile = checkDevice(size, 1200)

  const navbarBehaviour = () => {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      if (document.getElementById('navbar') != null) {
        document.getElementById('navbar').style.position = "fixed"
        document.getElementById('navbar').style.top = '0'
      }
    } else {
      if (document.getElementById('navbar') != null) {
        document.getElementById('navbar').style.position = "absolute"
        document.getElementById('navbar').style.top = "7vh"
      }
    }
  }

  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
    window.addEventListener("scroll", navbarBehaviour);
    return () =>
      window.removeEventListener("scroll", navbarBehaviour);
  }, []);
  const WIP = false;

  if (WIP) {
    return (
      <div className="App">
        <Placeholder />
        <Footer />
      </div>
    )
  } else {
    return (
      <div className="App">
        <LanguageProvider>
          {!isMobile ? <UpperNavbar /> : ''}
          {isMobile ? <MobileNavbar /> : <Navbar />}
          <Routes/>
          <Footer />
        </LanguageProvider>
      </div>

    )
  }
}

export default App;
